import { render, staticRenderFns } from "./ProductFilters.template.vue?vue&type=template&id=b50a7f40&scoped=true&"
var script = {}
import style0 from "./ProductFilters.template.vue?vue&type=style&index=0&id=b50a7f40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50a7f40",
  null
  
)

export default component.exports